/**
 * Locale interno usato per il sito internazionale.
 * Internamente il routing/i18n continua a usare `en-wx`; pubblicamente
 * (URL utente, hreflang, link SEO) il sito internazionale è servito su `/en`.
 */
export const INTERNAL_INTL_LOCALE = 'en-wx'

/** Segmento path pubblico del sito internazionale. */
export const PUBLIC_INTL_LOCALE = 'en'

/** Locale US usato da Algolia/Xgen per i product_url dell'indice americano. */
export const US_LOCALE = 'en-us'

/**
 * Converte un path che usa il locale interno `en-wx` nel path pubblico `/en`.
 * Lascia invariati tutti gli altri locale.
 *
 * @example
 * toPublicLocalePath('/en-wx/shoes')  // '/en/shoes'
 * toPublicLocalePath('/en-wx')        // '/en'
 * toPublicLocalePath('/it-it/scarpe') // '/it-it/scarpe' (invariato)
 */
// Module scope: both locales are constants, and these run once per product tile.
const INTERNAL_INTL_PREFIX = new RegExp(`^/${INTERNAL_INTL_LOCALE}(/|$)`, 'i')

export const toPublicLocalePath = (path: string): string =>
  path.replace(INTERNAL_INTL_PREFIX, `/${PUBLIC_INTL_LOCALE}$1`)

/**
 * Restituisce il segmento locale da usare pubblicamente in un URL/hreflang:
 * `en` per l'internazionale, altrimenti il locale stesso.
 *
 * @example
 * toPublicLocaleSegment('en-wx') // 'en'
 * toPublicLocaleSegment('it-it') // 'it-it'
 */
export const toPublicLocaleSegment = (locale: string): string =>
  locale.toLowerCase() === INTERNAL_INTL_LOCALE ? PUBLIC_INTL_LOCALE : locale

const US_LOCALE_PREFIX = new RegExp(`^/${US_LOCALE}(/|$)`, 'i')

const pathHasLocalePrefix = (path: string, locale: string): boolean => {
  if (!locale) return false
  const segment = path.match(/^\/([^/]+)(?=\/|$)/)?.[1]
  return segment?.toLowerCase() === locale.toLowerCase()
}

/**
 * Sul sito internazionale (en-wx), riscrive `/en-us/...` (product_url Algolia/Xgen US)
 * in `/en/...`. Su en-us e sugli altri locale il path resta invariato.
 */
export const rewriteUsLocaleForIntlSite = (
  path: string,
  internalLocale: string | undefined
): string => {
  if (internalLocale?.toLowerCase() !== INTERNAL_INTL_LOCALE) return path
  if (!pathHasLocalePrefix(path, US_LOCALE)) return path
  return path.replace(US_LOCALE_PREFIX, `/${PUBLIC_INTL_LOCALE}$1`)
}
